import type { PaletteConfig } from '../models/chart-config.model';
import { BUILT_IN_PALETTE_ID } from '../defaults/palette.default';

export function resolveEffectiveChartPaletteId(options: {
	configPalette?: Pick<
		PaletteConfig,
		'selectedPaletteId' | 'inheritsReportThemePalette'
	>;
	cardPaletteInput?: string;
	reportThemePaletteId?: string;
}): string {
	const { configPalette, cardPaletteInput, reportThemePaletteId } = options;
	if (configPalette?.inheritsReportThemePalette === true) {
		const fromTheme = reportThemePaletteId?.trim();
		if (fromTheme) return fromTheme;
	}
	const fromConfig = configPalette?.selectedPaletteId?.trim();
	if (fromConfig) return fromConfig;
	const fromInput = cardPaletteInput?.trim();
	if (fromInput) return fromInput;
	return BUILT_IN_PALETTE_ID;
}
